import { createFileRoute } from '@tanstack/react-router';
import { ErrorState } from '@/components/domain/ErrorState';
import { experimentDetailOptions } from '@/features/experiments/api';
import { ExperimentDetailPage } from '@/features/experiments/ExperimentDetailPage';

export const Route = createFileRoute('/_auth/experiments/$id')({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(experimentDetailOptions(params.id)),
  errorComponent: ({ error, reset }) => <ErrorState error={error} onRetry={reset} />,
  component: ExperimentDetailPage,
});
